import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchContent } from "./api";

export function useContent() {
  const { data } = useQuery({
    queryKey: ["content"],
    queryFn: fetchContent,
    staleTime: 60_000,
  });
  const c = (key, fallback = "") => {
    const v = data?.[key];
    return v === undefined || v === "" ? fallback : v;
  };
  const lines = (key, fallback = []) => {
    const v = data?.[key];
    if (!v) return fallback;
    return v.split("\n").map((s) => s.trim()).filter(Boolean);
  };
  const rows = (key, fallback = []) => {
    const v = data?.[key];
    if (!v) return fallback;
    return v
      .split("\n")
      .map((l) => l.split("|").map((s) => s.trim()))
      .filter((r) => r[0]);
  };
  const paragraphs = (key, fallback = []) => {
    const v = data?.[key];
    if (!v) return fallback;
    return v.split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean);
  };
  return { c, lines, rows, paragraphs, ready: !!data };
}

// *tekst* → accent-cursief in merkkleur
export function renderAccent(text, accentClass = "font-serif-italic text-ember font-normal") {
  if (!text) return text;
  const parts = String(text).split(/\*([^*]+)\*/g);
  if (parts.length === 1) return text;
  return parts.map((p, i) =>
    i % 2 === 1 ? (
      <span key={i} className={accentClass}>{p}</span>
    ) : (
      <React.Fragment key={i}>{p}</React.Fragment>
    )
  );
}
